import { SwaggerException } from '../sdk/sdk';
import { problemDetailMessage } from './problem-detail';

export const COMMISSION_ERROR_NOT_FOUND_MESSAGE = 'This record no longer exists — please refresh.';
export const COMMISSION_ERROR_FORBIDDEN_MESSAGE = "You don't have permission to do that.";
export const COMMISSION_ERROR_GENERIC_MESSAGE = 'Something went wrong, please try again.';

export function commissionErrorMessage(err: unknown): string {
  if (SwaggerException.isSwaggerException(err)) {
    if (err.status === 400 || err.status === 409) {
      const message = problemDetailMessage(err.response);
      if (message) {
        return message;
      }
    }
    if (err.status === 404) {
      return COMMISSION_ERROR_NOT_FOUND_MESSAGE;
    }
    if (err.status === 403) {
      return COMMISSION_ERROR_FORBIDDEN_MESSAGE;
    }
  }

  console.error('Commission/PPJ write failed', err);
  return COMMISSION_ERROR_GENERIC_MESSAGE;
}
